'use strict';

bbw.service.PostEditor = Class({

    UPLOAD_RESULT_SHOW_TIMEOUT: 2000,
    UPLOAD_ERROR_SHOW_TIMEOUT: 1000,

    statics: {
        FOCUS_EVENT: 'focus-post-editor',
        EDIT_EVENT: 'edit-post-editor',
        BLUR_EVENT: 'blur-posts-editor',
        SEQ: 1
    },

    entity: undefined,
    submitter: undefined,

    $inject: ['modelFactory', '$fancyModal', 'bbw.MsgToHtmlSvc', '$q', '$rootScope', 'bbw.PhotoAlbumGallerySvc', 'growl', 'FileUploader', 'bbwUrls', '$timeout'],

    /**
     * @type {bbw.service.MsgToHtmlSvc}
     */
    _msgToHtmlSvc: undefined,

    _modelFactory: undefined,
    $fancyModal: undefined,
    $q: undefined,
    $rootScope: undefined,
    _gallerySvc: undefined,
    _growl: undefined,
    _photoAlbum: undefined,
    _FileUploader: undefined,
    _bbwUrls: undefined,
    $timeout: undefined,
    _csrfToken: undefined,
    _allowedAsAdmin: false,
    hidden: false,
    number: undefined,

    construct: function(modelFactory, $fancyModal, msgToHtmlSvc, $q, $rootScope, gallerySvc, growl, FileUploader, bbwUrls, $timeout) {
        this.number = bbw.service.PostEditor.SEQ++;
        this._modelFactory = modelFactory;
        this.$fancyModal = $fancyModal;
        this._msgToHtmlSvc = msgToHtmlSvc;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this._gallerySvc = gallerySvc;
        this._growl = growl;
        this._FileUploader = FileUploader;
        this._bbwUrls = bbwUrls;
        this.$timeout = $timeout;
        this.uploads = [];
        this.input = {
            contents: '',
            uploads: this.uploads,
            disabled: false
        };
        this.state = {};
    },

    _getPhotoAlbum: function() {
        if (!this._photoAlbum) {
            this._photoAlbum = this._modelFactory.create(bbw.model.PhotoAlbum);
            this._photoAlbum.prepare({
                'size_name': 'small',
                'moderated_only': true
            });
        }
        return this._photoAlbum;
    },

    setCsrfToken: function(token) {
        this._csrfToken = token;
        this._initUploader();
        return this;
    },

    setReplyTo: function(comment) {
        if (!angular.isFunction(this.entity.setReplyTo)) {
            throw new Error("Entity does not implement replyTo()")
        }
        this.editInput(this._setReplyTo.bind(this, comment));
    },

    _setReplyTo: function(comment, value) {
        var existingUsername = this.entity.get('replyTo.admin') ? bbw.messages.admin : this.entity.get('replyTo.user.nickname');
        if (existingUsername) {
            var re = new RegExp('^(\\s*<(br|div)*\\s*\\/?>)*\\s*' + ngtk.tools.string.escapeRegexp(existingUsername + ',') + '\\s*', 'i');
            value = value.replace(re, '$1').replace(/^&nbsp;/, '').replace(/^\s*$/, '<div></div>');
        }
        this.entity.setReplyTo(comment || undefined);
        if (comment) {
            var prefix = comment.get('as_admin') ? bbw.messages.admin : comment.get('user.nickname');
            if (prefix && angular.isString(prefix) && prefix.length > 0) {
                prefix += ',';
                if (value.replace(/<(br|div)\s*\/?>/ig, '').trim().substr(0, prefix.length) !== prefix) {
                    value = prefix + '&nbsp;' + value;
                }
            }
        }
        return value;
    },

    attachPhotos: function() {
        this.blur();
        return this._openPhotosModal();
    },

    detachPhoto: function(photo) {
        photo.uncheck();
        this.entity.photos.removePhoto(photo);
    },

    getFocusEvent: function() {
        return bbw.service.PostEditor.FOCUS_EVENT + this.number;
    },

    getEditEvent: function() {
        return bbw.service.PostEditor.EDIT_EVENT + this.number;
    },

    editInput: function(fn) {
        this.$rootScope.$broadcast(this.getEditEvent(), {fn: fn});
    },

    focus: function() {
        this.$rootScope.$broadcast(this.getFocusEvent());
    },

    isNew: function() {
        return !!this.entity.get('id');
    },

    setHidden: function(isHidden) {
        this.hidden = angular.isDefined(isHidden) ? !!isHidden : true;
        return this;
    },

    setVisible: function(isVisible) {
        this.hidden = angular.isDefined(isVisible) ? !isVisible : false;
        return this;
    },

    openAttachesGallery: function(index) {
        this._gallerySvc.openGallery({}, this.entity.photos, index || 0);
    },

    getPhotosTotalLength: function() {
        return this.entity.photos.getLength();
    },

    getRemainingPhotoSlotsCount: function() {
        return this.entity.photos.getRemainingPhotoSlotsCount();
    },

    getUploadedPhotosCount: function() {
        var count = 0;
        this.entity.photos.forEach(function(photo) {
            if (photo.get('album_type') == 'contents') {
                count++;
            }
        });
        return count;
    },

    _openPhotosModal: function() {
        var deferred = this.$q.defer();
        var $scope = this.$rootScope.$new();
        $scope.albumModel = this._getPhotoAlbum();
        $scope.albumModelCheckedPhotoIds = [];
        this.entity.photos.forEach(function(photo) {
            var photoId = photo.get('id');
            photoId && $scope.albumModelCheckedPhotoIds.push(photoId);
        }.bind(this));
        $scope.ensureCanAttach = function(photoModel, count) {
            if (photoModel.isChecked()) {
                return true;
            }
            if (count + this.input.uploads.length + this.getUploadedPhotosCount() >= bbw.configuration.post.attached_photos_limit) {
                this._growl.error(['chat_attach_limit_exceeded', bbw.configuration.post.attached_photos_limit]);
                return false;
            }
            return true;
        }.bind(this);

        var getPhotoAlbum = this._getPhotoAlbum.bind(this);

        this.$fancyModal.open({
            templateUrl: bbw.templateUrl('post-attach.html'),
            themeClass: 'chat-attach',
            scope: $scope,
            controller: ['$scope', function($scope) {
                $scope.getSelectedPhotosCount = function() {
                    var result = 0;
                    getPhotoAlbum().forEach(function(photo) {
                        if (photo.isChecked()) {
                            ++result;
                        }
                    });
                    return result;
                };
                $scope.initialSelectedCount = $scope.getSelectedPhotosCount();
                $scope.ok = function() {
                    deferred.resolve(true);
                    $scope.$modal.close();
                };
                $scope.cancel = function() {
                    deferred.resolve(false);
                    $scope.$modal.close();
                };
            }]
        });

        var onResolve = function(success) {
            if (success) {
                getPhotoAlbum().forEach(function(photo) {
                    if (photo.isChecked()) {
                        this.entity.photos.addPhoto(photo);
                    } else {
                        this.entity.photos.removePhoto(photo);
                    }
                }.bind(this));
            }
        }.bind(this);

        return deferred.promise.then(onResolve);
    },

    canSave: function() {
        return this.isValid() && this.uploads.length == 0 && !this.input.disabled && !this.input.publishing && this.entity.isEditable();
    },

    isValid: function() {
        return this.input.contents.trim().length > 0 || this.entity.hasPhotos();
    },

    setSubmitter: function(fn) {
        this.submitter = fn;
    },

    submit: function() {
        if (!angular.isFunction(this.submitter)) {
            throw new Error("Submitter is undefined");
        }
        var result = (this.submitter)();
        if (angular.isObject(result) && angular.isFunction(result.finally)) {
            this.setInputEnabled(false);
            this.input.publishing = true;
            result.finally(function() {
                delete this.input.publishing;
                this.setInputEnabled(true);
            }.bind(this));
        }
        return result;
    },

    setEditedContents: function(value, title, collectionIdentifier, asAdmin) {
        this.entity.merge(ngtk.tools.object.filter({
            contents: value || '',
            title: title || undefined,
            collection_identifier: collectionIdentifier ? parseInt(collectionIdentifier) : undefined,
            as_admin: !!asAdmin
        }));
    },

    getEntity: function() {
        return this.entity;
    },

    allowAsAdmin: function(value) {
        if (angular.isUndefined(value)) {
            value = true;
        }
        this._allowedAsAdmin = !!value;
        return this;
    },

    isAllowedAsAdmin: function() {
        return this._allowedAsAdmin;
    },

    empty: function() {
        if (!this.entity) {
            return;
        }
        this.entity.empty();
        this.entity.photos.clean();
        this.entity.merge({is_own: true});
        this._getPhotoAlbum().forEach(function(photo) {
            photo.uncheck();
        }.bind(this));
        this._emptyInput();
    },

    setInputEnabled: function(isEnabled) {
        this.input.disabled = !isEnabled;
        return this;
    },

    setPublishing: function(isPublishing) {
        this.input.publishing = !!isPublishing;
        this.setInputEnabled(!isPublishing);
        return this;
    },

    cancel: function() {
        this.rollback();
        this.setHidden();
    },

    rollback: function() {
        if (!this.entity) {
            return;
        }
        this.entity.setContents(this.origContents, this.origPhotos);
        this.entity.setTitle && this.entity.setTitle(this.origTitle);
        this.entity.setCollectionIdentifier && this.entity.setCollectionIdentifier(this.origCollectionIdentifier);
        this._updateInput();
    },

    setEntity: function(entity) {
        this.entity = entity;
        if (this.entity) {
            this._allowedAsAdmin = (
                bbw.userIsModerator
                && (!entity.get('id') || entity.get('user_id') == bbw.userId || entity.get('as_admin'))
                && entity.get('type_name') != 'blog'
                && entity.get('type_name') != 'wall'
            );
            this.commit();
            this._updateInput();
        } else {
            this._allowedAsAdmin = false;
        }
        return this;
    },

    _updateInput: function() {
        this._emptyInput();
        this.input.contents = this._msgToHtmlSvc.msgToHtml(this.entity.getContents());
        this.input.title = this.entity.getTitle ? this.entity.getTitle() : undefined;
        this.input.as_admin = !!this.entity.get('as_admin');
        this.input.collection_identifier = (
            this.entity.getCollectionIdentifier ? +this.entity.getCollectionIdentifier() : undefined
        ) || this.defaultCollectionIdentifier;
        // console.log(this.input);
    },

    setDefaultCollectionIdentifier: function(value) {
        this.defaultCollectionIdentifier = value;
        if (this.hidden || angular.isUndefined(this.input.collection_identifier)) {
            this.input.collection_identifier = value;
        }
        return this;
    },

    commit: function() {
        if (!this.entity) {
            return;
        }
        this.origContents = this.entity.getContents();
        this.origPhotos = this._clonePhotos(this.entity.photos);
        if (this.entity.getTitle) {
            this.origTitle = this.entity.getTitle();
        } else {
            this.origTitle = undefined;
        }
        if (this.entity.getCollectionIdentifier) {
            this.origCollectionIdentifier = this.entity.getCollectionIdentifier();
        } else {
            this.origCollectionIdentifier = undefined;
        }
    },

    _clonePhotos: function(photos) {
        var clone = this._modelFactory.create(bbw.model.PhotoCollection);
        photos.forEach(function(photo) {
            clone.set(undefined, photo);
        });
        return clone;
    },

    _initUploader: function() {
        this.uploads.length = 0;

        this.input.uploaderId = 'postFileSelectUploader_' + this.number;
        this.uploaderSelector = '#' + this.input.uploaderId;

        this.uploadsAllowedExtensions = bbw.configuration.photos.accept.extensions.map(function(ext) {
            return '.' + ext;
        }).join(',');

        var config = bbw.configuration.photos.accept;
        var albumArgs = {
            album_type: 'contents',
            size: 'small',
            extra_size: 'tiny',
            full_size: 'default'
        };

        this.uploader = new (this._FileUploader)({
            url: this._bbwUrls.photo_upload,
            formData: [{_token: this._csrfToken}, albumArgs],
            removeAfterUpload: true,
            autoUpload: true,
            filters: [
                {
                    name: "image",
                    fn: function(item) {
                        var error;
                        if (!item.size) {
                            error = ['file_is_empty', item.name];
                        } else if (item.size >= config.maxSizeMb * 1024 * 1024) {
                            error = ['file_size_exceeds', item.name, config.maxSizeMb];
                        } else if (!item.type.match(config.mimeRegexp) || !this._isFileNameExtensionAllowed(item.name)) {
                            error = ['file_is_not_image', item.name];
                        } else if (this.getRemainingPhotoSlotsCount() <= this.uploader.queue.length) {
                            error = ['chat_attach_limit_exceeded', bbw.configuration.post.attached_photos_limit];
                        }
                        if (error) {
                            this._growl.error(error);
                            return false;
                        } else {
                            return true;
                        }
                    }.bind(this)
                }
            ]
        });

        this.uploader.onAfterAddingFile = function(fileItem) {
            console.info('onAfterAddingFile', fileItem);
            this._addUploadProgress(fileItem);
        }.bind(this);
        this.uploader.onAfterAddingAll = function(addedFileItems) {
            console.info('onAfterAddingAll', addedFileItems);
        };
        this.uploader.onBeforeUploadItem = function(item) {
            console.info('onBeforeUploadItem', item);
        }.bind(this);
        this.uploader.onProgressItem = function(fileItem, progress) {
            console.info('onProgressItem', fileItem, progress);
            this._updateUploadProgress(fileItem, progress);
        }.bind(this);
        this.uploader.onProgressAll = function(progress) {
            console.info('onProgressAll', progress);
        };
        this.uploader.onSuccessItem = function(fileItem, response, status, headers) {
            console.info('onSuccessItem', fileItem, response, status, headers);
            this._setUploadSuccess(fileItem, response.photo);
        }.bind(this);
        this.uploader.onErrorItem = function(fileItem, response, status, headers) {
            console.info('onErrorItem', fileItem, response, status, headers);
            this._setUploadError(fileItem, response.error);
        }.bind(this);
        this.uploader.onCancelItem = function(fileItem, response, status, headers) {
            console.info('onCancelItem', fileItem, response, status, headers);
            this._setUploadError(fileItem, response.error);
        }.bind(this);
        this.uploader.onCompleteItem = function(fileItem, response, status, headers) {
            console.info('onCompleteItem', fileItem, response, status, headers);
            if (!angular.isObject(response)) {
                this._setUploadError(fileItem, 'internal_error');
            } else if (response.error) {
                this._setUploadError(fileItem, response.error);
            } else {
                this._addPhotoByData(response.photo);
            }
        }.bind(this);
        this.uploader.onCompleteAll = function() {
            console.info('onCompleteAll');
            this._setTimeout(function() {
                this.uploads = this.uploads.filter(function(upload) {
                    return !upload.error;
                })
            }.bind(this), this.UPLOAD_ERROR_SHOW_TIMEOUT);
        }.bind(this);
    },

    _addPhotoByData: function(data) {
        var photo = this._modelFactory.create(bbw.model.Photo);
        data.$success = true;
        photo.merge(data);
        this.entity.photos.addPhoto(photo);
        this._setTimeout(function() {
            photo.merge({$success: undefined});
        }.bind(this), this.UPLOAD_RESULT_SHOW_TIMEOUT);
    },

    _addUploadProgress: function(fileItem) {
        this.$rootScope.$safeApply(function() {
            this.uploads.push({file: fileItem, progress: 0, isUploading: true});
        }.bind(this));
    },

    _findUpload: function(fileItem, fn) {
        return this.uploads.some(
                function(uploadItem, idx) {
                    if (angular.equals(uploadItem.file, fileItem)) {
                        return fn(uploadItem, idx);
                    }
                }
            ) && this.$rootScope.$safeApply();
    },

    _updateUploadProgress: function(fileItem, progress) {
        this._findUpload(fileItem, function(uploadItem) {
            uploadItem.progress = progress;
            return true;
        });
    },

    _setUploadSuccess: function(fileItem) {
        this._findUpload(fileItem, function(uploadItem, idx) {
            this.uploads.splice(idx, 1);
            return true;
        }.bind(this));
    },

    _setUploadError: function(fileItem, error) {
        var err;
        switch (error) {
            case 'photo_max_size_exceeded':
                err = ['file_size_exceeds', fileItem.file.name, bbw.configuration.photos.accept.maxSizeMb];
                break;
            case 'photo_max_dim_exceeded':
                err = ['file_dim_exceeds', fileItem.file.name];
                break;
            case 'photo_min_dim_required':
                err = ['file_dim_low', fileItem.file.name];
                break;
            case 'photo_invalid_type':
                err = ['file_is_unknown_image', fileItem.file.name];
                break;
            case 'photo_not_uploaded':
            default:
                err = ['file_is_not_image', fileItem.file.name];
        }
        this._growl.error(err);
        this._updateUploadStatus(fileItem, 'error', error) || this.uploads.push({error: error});
    },

    _updateUploadStatus: function(fileItem, status, value) {
        this._findUpload(fileItem, function(uploadItem) {
            uploadItem[status] = angular.isDefined(value) ? value : true;
            delete uploadItem.isUploading;
            return true;
        });
    },

    _isFileNameExtensionAllowed: function(filename) {
        try {
            var ext = (filename.match(/[^.]+\.([^.]+)$/))[1].toLowerCase();
        } catch (e) {
            return false;
        }
        return bbw.configuration.photos.accept.extensions.some(function(acceptedExt) {
            return ext === acceptedExt;
        });
    },

    _emptyInput: function() {
        this.blur();
        this.input.contents = '';
        this.input.title = undefined;
        this.input.collection_identifier = undefined;
        this.input.as_admin = false;
        this.input.uploads.length = 0;
    },

    blur: function() {
        this.$rootScope.$broadcast(bbw.service.PostEditor.BLUR_EVENT);
    },

    _setTimeout: function(fn, timeout) {
        return this.$timeout(fn, timeout);
    }

});
